import { useState } from 'react';
import { newId, type ServicesModule, type ServiceItem } from '@inboundhost/shared';

interface Props {
  value: ServicesModule | null;
  onSave: (v: ServicesModule) => void;
}

export function ServicesEditor({ value, onSave }: Props) {
  const [items, setItems] = useState<ServiceItem[]>(value?.items ?? []);

  function update(i: number, patch: Partial<ServiceItem>) {
    setItems(items.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));
  }

  function add() {
    setItems([...items, { id: newId('svc'), name: '' }]);
  }

  function remove(i: number) {
    setItems(items.filter((_, idx) => idx !== i));
  }

  return (
    <div className="bg-white rounded shadow p-6">
      <ul className="space-y-3 mb-4">
        {items.map((item, i) => (
          <li key={item.id} className="grid grid-cols-12 gap-2 items-start">
            <input
              className="col-span-3 border rounded px-2 py-1"
              placeholder="Name"
              value={item.name}
              onChange={(e) => update(i, { name: e.target.value })}
            />
            <input
              className="col-span-4 border rounded px-2 py-1"
              placeholder="Description"
              value={item.description ?? ''}
              onChange={(e) => update(i, { description: e.target.value })}
            />
            <input
              type="number"
              step="0.01"
              className="col-span-2 border rounded px-2 py-1"
              placeholder="Price"
              value={item.price ?? ''}
              onChange={(e) => update(i, { price: e.target.value ? Number(e.target.value) : undefined })}
            />
            <input
              type="number"
              className="col-span-2 border rounded px-2 py-1"
              placeholder="Min"
              value={item.durationMinutes ?? ''}
              onChange={(e) =>
                update(i, {
                  durationMinutes: e.target.value ? Number(e.target.value) : undefined,
                })
              }
            />
            <button type="button" className="col-span-1 text-red-600 text-sm" onClick={() => remove(i)}>
              Remove
            </button>
          </li>
        ))}
      </ul>

      <div className="flex gap-3">
        <button type="button" onClick={add} className="px-3 py-1 border rounded text-sm hover:bg-gray-50">
          + Add service
        </button>
        <button
          type="button"
          onClick={() => onSave({ items })}
          className="bg-gray-900 text-white px-4 py-1 rounded hover:bg-gray-800"
        >
          Save services
        </button>
      </div>
    </div>
  );
}
